export const checkAuthToken = () => {
    const authToken = localStorage.getItem("Authorization");
    if (authToken && authToken !== "null") {
        return true;
    }
    return false;
};

export const setAuthToken = (authToken, refreshToken) => {
    localStorage.setItem("Authorization", authToken);
    localStorage.setItem("RefreshToken", refreshToken);
};

export const getAuthToken = () => ({
    authToken: localStorage.getItem("Authorization"),
    refreshToken: localStorage.getItem("RefreshToken")
});

export const removeAuthToken = () => {
    localStorage.removeItem("Authorization");
    localStorage.removeItem("RefreshToken");
    sessionStorage.removeItem("caseListingRedirected");
};
